import { render, staticRenderFns } from "./PartnerPage.vue?vue&type=template&id=6bc9f735&scoped=true"
import script from "./PartnerPage.vue?vue&type=script&lang=js"
export * from "./PartnerPage.vue?vue&type=script&lang=js"
import style0 from "./PartnerPage.vue?vue&type=style&index=0&id=6bc9f735&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc9f735",
  null
  
)

export default component.exports